import BoxContainerSmall from './BoxContainerSmall'

export default BoxContainerSmall
